// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var SimulationModel;
(function (SimulationModel) {
    SimulationModel[SimulationModel["ByAbsolutePrices"] = 0] = "ByAbsolutePrices";
    SimulationModel[SimulationModel["ByRelativePrices"] = 1] = "ByRelativePrices";
    SimulationModel[SimulationModel["ByLogarithmicPrices"] = 2] = "ByLogarithmicPrices";
})(SimulationModel || (SimulationModel = {}));
